// Keep native contact submission and Shopify's challenge/error handling.
class DealerApplication extends HTMLElement {
  #cleanup;
  connectedCallback() {
    if (this.#cleanup) return;
    const form = this.querySelector('form');
    const button = form?.querySelector('button[type="submit"]');
    const label = button?.textContent;
    let pending = false;
    let timer;
    const restore = () => {
      clearTimeout(timer);
      pending = false;
      form?.removeAttribute('aria-busy');
      if (button) { button.disabled = false; button.textContent = label; }
    };
    const submit = event => {
      if (pending) { event.preventDefault(); return; }
      pending = true;
      form.setAttribute('aria-busy', 'true');
      if (button) { button.disabled = true; button.textContent = button.dataset.submitting || label; }
      timer = setTimeout(restore, 15000);
    };
    form?.addEventListener('submit', submit);
    window.addEventListener('pageshow', restore);
    this.querySelector('[data-dealer-result]')?.focus();
    this.#cleanup = () => {
      restore();
      form?.removeEventListener('submit', submit);
      window.removeEventListener('pageshow', restore);
    };
  }
  disconnectedCallback() { this.#cleanup?.(); this.#cleanup = null; }
}
if (!customElements.get('tt-dealer-application')) customElements.define('tt-dealer-application', DealerApplication);
